module.exports = __webpack_public_path__ + "static/media/grid-item-b10.57a1e17a.png";